import { Component, OnInit, ViewEncapsulation, signal } from '@angular/core'
import dayjs from 'dayjs'
import { ToastrService } from 'ngx-toastr'
import { UserReviewClient } from 'src/app/shared/services/ppv.api'
import { RECEPTION_REVIEW_TEMPLATE } from '../dvm-tool-plan/review-template-reception'
import { CROSS_TRAINED_REVIEW_TEMPLATE } from '../dvm-tool-plan/review-template-cross-trained'
import { CLINICAL_REVIEW_TEMPLATE } from '../dvm-tool-plan/review-template-clinical'
import {
   DVMToolTeamDashboardComponent,
   DashboardRow,
   FullReviewPreviewQuestion,
   FullReviewPreviewSection,
   AdditionalResponsibilityRow,
} from './dvm-tool-team-dashboard.component'

const JOB_DESC_BASE = 'https://vetcor.skyworld.com/userfilesV3/files/document-library/Performance%20Hub/'

const JOB_DESCRIPTIONS: Record<string, { label: string; url: string }> = {
   CCS: { label: 'Client Care Representative', url: JOB_DESC_BASE + 'Client%20Care%20Representative%20Job%20Description%20Final.pdf' },
   'CCS-L': {
      label: 'Lead Client Care Representative',
      url: JOB_DESC_BASE + 'Lead%20Client%20Care%20Representative%20Job%20Description%20Final.pdf',
   },
   'GROOM--G': { label: 'Groomer', url: JOB_DESC_BASE + 'Groomer%20Job%20Description%20Final.pdf' },
   'PCA-L': { label: 'Lead Kennel Attendant', url: JOB_DESC_BASE + 'Lead%20Kennel%20Attendant%20Job%20Description%20Final.pdf' },
   'PCA / Kennel LAH': { label: 'Kennel Attendant', url: JOB_DESC_BASE + 'Kennel%20Attendant%20Job%20Description%20Final.pdf' },
   'PETCARE-': { label: 'Kennel Attendant', url: JOB_DESC_BASE + 'Kennel%20Attendant%20Job%20Description%20Final.pdf' },
   TECH: { label: 'Veterinary Technician', url: JOB_DESC_BASE + 'Veterinary%20Technician%20Job%20Description%20Final.pdf' },
   'TECH-AST': { label: 'Veterinary Assistant', url: JOB_DESC_BASE + 'Veterinary%20Assistant%20Job%20Description%20Final.pdf' },
   'TECH-L': { label: 'Lead Veterinary Technician', url: JOB_DESC_BASE + 'Lead%20Veterinary%20Technician%20Job%20Description%20Final.pdf' },
   'TECH-LVT': {
      label: 'Credentialed Veterinary Technician',
      url: JOB_DESC_BASE + 'Credentialed%20Veterinary%20Technician%20Job%20Description%20Final.pdf',
   },
   LEAD_TECH_LVT: {
      label: 'Lead Credentialed Veterinary Technician',
      url: JOB_DESC_BASE + 'Lead%20Credentialed%20Veterinary%20Technician%20Job%20Description%20Final.pdf',
   },
   INVENTORY_MANAGER: { label: 'Veterinary Technician', url: JOB_DESC_BASE + 'Veterinary%20Technician%20Job%20Description%20Final.pdf' },
   LEAD_VET_ASSISTANT: { label: 'Veterinary Assistant', url: JOB_DESC_BASE + 'Veterinary%20Assistant%20Job%20Description%20Final.pdf' },
   VET_ASSISTANT_LG_ANIMAL: { label: 'Veterinary Assistant', url: JOB_DESC_BASE + 'Veterinary%20Assistant%20Job%20Description%20Final.pdf' },
   MAINT: { label: 'Kennel Attendant', url: JOB_DESC_BASE + 'Kennel%20Attendant%20Job%20Description%20Final.pdf' },
   AHM: { label: 'Assistant Hospital Manager', url: JOB_DESC_BASE + 'Assistant%20Hospital%20Manager%20Job%20Description%20Final.pdf' },
   BFM: { label: 'Lead Kennel Attendant', url: JOB_DESC_BASE + 'Lead%20Kennel%20Attendant%20Job%20Description%20Final.pdf' },
}

@Component({
   selector: 'dvm-tool-team-dashboard-modals',
   templateUrl: './dvm-tool-team-dashboard-modals.component.html',
   styleUrls: ['./dvm-tool-team-dashboard-modals.component.scss'],
   standalone: false,
   encapsulation: ViewEncapsulation.None,
})
export class DVMToolTeamDashboardModalsComponent implements OnInit {
   constructor(
      public dash: DVMToolTeamDashboardComponent,
      private toastr: ToastrService,
      private userReviewClient: UserReviewClient
   ) {}

   ngOnInit(): void {
      this.dontShowGettingStarted = this.isGettingStartedHidden()

      if (!this.dontShowGettingStarted) {
         setTimeout(() => {
            this.showteamModal = true
         }, 800)
      }
   }

   showteamModal = false

   dontShowGettingStarted = false

   userResponsibilitiesDialog = signal<{ show: boolean; row: DashboardRow | null }>({ show: false, row: null })

   responsibilityRows: AdditionalResponsibilityRow[] = []

   isResponsibilitiesLoaded = false

   isSavingResponsibilities = false

   assignmentPanelOpen = false

   activeResponsibilityIndex: number | null = null

   assignmentSearch = ''

   jobDescDialog = signal<{ show: boolean; row: DashboardRow | null }>({ show: false, row: null })

   jobDescSelections: Record<string, boolean> = {}

   isJobDescsLoaded = false

   isSavingJobDescs = false

   showFullReviewPreview = false

   fullReviewSections: FullReviewPreviewSection[] = []

   dupSaveDialog: { show: boolean; matches: Array<{ text: string; existing: string }> } = { show: false, matches: [] }

   responsibilityPreviewOptions: string[] = [
      'Sets the Standard for Others',
      'Successful',
      'Opportunity for Improvement',
      'Not Successful',
      'Not Applicable',
   ]

   private dupCheckTimer: ReturnType<typeof setTimeout> | null = null

   private existingReviewQuestionsCache: string[] | null = null

   userDeferDialog = signal<{ show: boolean; row: DashboardRow | null }>({ show: false, row: null })

   userFollowUpDialog = signal<{ show: boolean; row: DashboardRow | null }>({ show: false, row: null })

   userFollowUpDeferredOn: Date | string | null = null

   rejectedDialog = signal<{ show: boolean; row: DashboardRow | null }>({ show: false, row: null })

   rejectedDialogRejectReason = ''

   rejectedDialogResolvedBy = ''

   rejectedDialogResolvedOn: Date | string | null = null

   userFollowUpMessages: {
      id: number
      deferralId: number
      message: string
      sentById: string
      sentByName: string
      isAdmin: boolean
      sentOn: Date | string
   }[] = []

   userFollowUpMessage = ''

   userFollowUpLoading = false

   userFollowUpSaving = false

   deferReasonCategory = ''

   deferCategoryOpen = false

   deferQuarter: string | null = null

   readonly deferQuarterOptions: Array<{ value: string; label: string; sub: string; endsOn: string }> = [
      { value: 'Q4 2026', label: 'Q4 2026', sub: '(Oct – Dec)', endsOn: '2026-12-31' },
      { value: 'Q1 2027', label: 'Q1 2027', sub: '(Jan – Mar)', endsOn: '2027-03-31' },
      { value: 'Q2 2027', label: 'Q2 2027', sub: '(Apr – Jun)', endsOn: '2027-06-30' },
      { value: 'Q3 2027', label: 'Q3 2027', sub: '(Jul – Sep)', endsOn: '2027-09-30' },
      { value: '1 Year', label: '1 Year', sub: '', endsOn: '' },
   ]

   readonly deferCategoryOptions = [
      {
         label: 'Newly hired employee',
         description: 'The team member has not been in the role long enough (e.g., less than 60–90 days) to complete a meaningful annual review.',
      },
      {
         label: 'Recently completed review or promotion',
         description: 'The employee recently underwent a performance review tied to a promotion, transfer, role change, or compensation adjustment.',
      },
      {
         label: 'Extended leave of absence',
         description: 'The employee was on extended medical, parental, military, or personal leave for a significant portion of the review period.',
      },
      {
         label: 'Insufficient time under current manager',
         description:
            'The employee changed departments, positions, or reporting structures during the review cycle, making a standard review less applicable.',
      },
      {
         label: 'Performance improvement or corrective action process already in progress',
         description: 'The employee is currently on a formal coaching or performance improvement plan with separate documented evaluation timelines.',
      },
      {
         label: 'Separation from the organization',
         description: 'The employee has submitted resignation notice, has a planned termination date, or is otherwise exiting the organization.',
      },
      { label: 'Relief or Seasonal', description: "The individual may not fall within the organization's standard annual review process." },
      { label: 'Other', description: '' },
   ]

   get canSelectDeferQuarter(): boolean {
      if (
         this.deferReasonCategory == this.deferCategoryOptions[1].label ||
         this.deferReasonCategory == this.deferCategoryOptions[2].label ||
         this.deferReasonCategory == this.deferCategoryOptions[4].label ||
         this.deferReasonCategory == this.deferCategoryOptions[5].label
      ) {
         return true
      } else if (this.deferReasonCategory == 'Relief or Seasonal' && this.userDeferDialog().row?.payClass?.toLowerCase().includes('seasonal')) {
         return true
      } else if (
         this.deferReasonCategory == 'Newly hired employee' &&
         dayjs(this.userDeferDialog()?.row.hireDate).isAfter(dayjs().subtract(9, 'month'))
      ) {
         return true
      }
      return false
   }

   get needsAdminApproval(): boolean {
      if (!this.canSelectDeferQuarter && this.deferReasonCategory == 'Newly hired employee') {
         return true
      } else if (this.deferReasonCategory == this.deferCategoryOptions[3].label) {
         return true
      } else if (!this.canSelectDeferQuarter && this.deferReasonCategory == 'Relief or Seasonal') {
         return true
      } else if (this.deferReasonCategory == 'Other') {
         return true
      }
      return false
   }

   get isAutoApprovedDeferral(): boolean {
      return !!this.deferQuarter
   }

   selectDeferQuarter(value: string | null): void {
      if (value && !this.canSelectDeferQuarter) return
      this.deferQuarter = value
   }

   deferReason = ''

   isSubmittingUpdate = false

   lockedJobDesc = ''

   jobDescriptionOptions: Array<{ label: string; url: string }> = Array.from(
      new Map(Object.values(JOB_DESCRIPTIONS).map((d) => [d.label, d])).values()
   )

   closeteamModal(): void {
      this.showteamModal = false
      this.setGettingStartedHidden(this.dontShowGettingStarted)
   }

   reopenGettingStarted(): void {
      this.showteamModal = true
   }

   private get gettingStartedStorageKey(): string {
      return `phub-getting-started-hidden-${this.dash.userId ?? 'anon'}`
   }

   isGettingStartedHidden(): boolean {
      try {
         return localStorage.getItem(this.gettingStartedStorageKey) === 'true'
      } catch {
         return false
      }
   }

   private setGettingStartedHidden(hidden: boolean): void {
      try {
         if (hidden) {
            localStorage.setItem(this.gettingStartedStorageKey, 'true')
         } else {
            localStorage.removeItem(this.gettingStartedStorageKey)
         }
      } catch {}
   }

   showExportModal = false

   exportColumns: Array<{ key: string; label: string; icon: string; selected: boolean }> = []

   openExportModal(): void {
      this.exportColumns = [
         { key: 'name', label: this.dash.getRevieweeLabel(false), icon: 'fa-user', selected: true },
         { key: 'hospitalName', label: 'Hospital Name', icon: 'fa-house-medical', selected: true },
         { key: 'hireDate', label: 'Hire Date', icon: 'fa-calendar-day', selected: true },
         { key: 'jobTitleCode', label: 'Job Role', icon: 'fa-id-badge', selected: true },
         { key: 'jobTitle', label: 'Job Title', icon: 'fa-briefcase', selected: true },
         { key: 'reviewerName', label: this.dash.getReviewerLabel(false), icon: 'fa-user-tie', selected: true },
         { key: 'hmEmail', label: 'Hospital Manager Email', icon: 'fa-envelope', selected: true },
         { key: 'reviewType', label: 'Review Type', icon: 'fa-clipboard-list', selected: true },
         { key: 'payClass', label: 'Pay Class', icon: 'fa-business-time', selected: true },
         { key: 'dvmSubmittedOn', label: `${this.dash.getRevieweeLabel(true)} Submitted`, icon: 'fa-paper-plane', selected: true },
         { key: 'cosSubmittedOn', label: `${this.dash.getReviewerLabel(true)} Submitted`, icon: 'fa-user-check', selected: true },
         { key: 'status', label: 'Submission Status', icon: 'fa-circle-check', selected: true },
         { key: 'isDeferred', label: 'User Deferred?', icon: 'fa-hourglass-half', selected: true },
      ]
      this.showExportModal = true
   }

   closeExportModal(): void {
      this.showExportModal = false
   }

   get selectedExportCount(): number {
      return this.exportColumns.filter((c) => c.selected).length
   }

   setAllExportColumns(selected: boolean): void {
      this.exportColumns.forEach((c) => (c.selected = selected))
   }

   exportDashboardRowsXlsx(): void {
      const rows: DashboardRow[] = [...(this.dash.dashboardRows ?? [])]
         .filter((r) => r.revieweeUserStatus != 'LOAINACTIVE')
         .sort(
            (a, b) =>
               (a.reviewType ?? '').localeCompare(b.reviewType ?? '') ||
               (a.name ?? '').localeCompare(b.name ?? '', undefined, { sensitivity: 'base' })
         )
      const cols = this.exportColumns.filter((c) => c.selected)
      if (!rows.length || !cols.length) return

      const colWidths: Record<string, number> = {
         hospitalName: 30,
         name: 24,
         hireDate: 12,
         jobTitleCode: 10,
         jobTitle: 22,
         payClass: 12,
         reviewType: 15,
         hospital: 26,
         dvmSubmittedOn: 17,
         cosSubmittedOn: 17,
         reviewerName: 22,
         hmEmail: 24,
         status: 15,
         isDeferred: 14,
      }

      const statusLabels: Record<string, string> = {
         completed: 'Completed',
         'in-review': 'In Review',
         'in-progress': 'In Progress',
         'not-started': 'Not Started',
      }
      const statusFontRgb: Record<string, string> = {
         completed: '18A880',
         'in-review': '0672BA',
         'in-progress': '90278E',
         'not-started': '979797',
      }

      const aoa: any[][] = [cols.map((c) => this.xlsxHdr(c.label))]

      rows.forEach((r, i) => {
         const bg = i % 2 === 0 ? 'FFFFFF' : 'F2F8F8'
         aoa.push(
            cols.map((c) => {
               switch (c.key) {
                  case 'hospitalName':
                  case 'hospital':
                     return this.xlsxCell(r.practice, bg)
                  case 'hireDate':
                     return this.xlsxCell(
                        r.hireDate && this.dash.isValidDate(r.hireDate) ? dayjs(r.hireDate).format('M/D/YYYY') : (r.hireDate ?? ''),
                        bg
                     )
                  case 'payClass':
                     return this.xlsxCell(r.payClass == 'FT' ? 'Full-time' : r.payClass == 'PT' ? 'Part-time' : (r.payClass ?? ''), bg)
                  case 'reviewType':
                     return this.xlsxCell(
                        r.reviewType == 'CLINICAL'
                           ? 'Clinical'
                           : r.reviewType == 'CROSSTRAINED'
                             ? 'Cross-Trained'
                             : r.reviewType == 'RECEPTION'
                               ? 'Reception'
                               : (r.reviewType ?? ''),
                        bg
                     )
                  case 'dvmSubmittedOn':
                     return this.dash.isIncompleteSubmitted(r.isDVMSubmitted, r.dvmSubmittedOn)
                        ? this.xlsxCell('INCOMPLETE', bg, true, 'E65100')
                        : this.xlsxCell(r.dvmSubmittedOn, bg)
                  case 'cosSubmittedOn':
                     return this.dash.isIncompleteSubmitted(r.isCOSSubmitted, r.cosSubmittedOn)
                        ? this.xlsxCell('INCOMPLETE', bg, true, 'E65100')
                        : this.xlsxCell(r.cosSubmittedOn, bg)
                  case 'reviewerName':
                     return this.xlsxCell(this.dash.getReviewerName(r) ?? '', bg)
                  case 'hmEmail': {
                     const cell = this.xlsxCell(r.hmEmail ?? '', bg)
                     if (r.hmEmail) {
                        cell.l = { Target: `mailto:${r.hmEmail}`, Tooltip: `Email ${this.dash.getReviewerName(r) ?? r.hmEmail}` }
                        cell.s.font.color = { rgb: '0563C1' }
                        cell.s.font.underline = true
                     }
                     return cell
                  }
                  case 'status': {
                     const s = this.dash.getReviewStatus(r)
                     return this.xlsxCell(statusLabels[s] ?? s, bg, true, statusFontRgb[s] ?? '1A2B2A')
                  }
                  case 'isDeferred':
                     return r.isDeferred && r.deferralStatus == 'Approved' ? this.xlsxCell('Yes', bg, true, 'B45309') : this.xlsxCell('-', bg)
                  default:
                     return this.xlsxCell((r as any)?.[c.key] ?? '', bg)
               }
            })
         )
      })

      const filename = `performance-hub-${dayjs().format('YYYY-MM-DD')}.xlsx`
      this.xlsxDownload(
         aoa,
         cols.map((c) => colWidths[c.key] ?? 16),
         'Performance Hub',
         filename
      )
      this.closeExportModal()
   }

   exportHospitalStatusXlsx(): void {
      const allRows: DashboardRow[] = [...(this.dash.allRows ?? [])]
      const userName = (this.dash.userName ?? '').trim()

      const homePractices = new Set<string>()
      if (userName) {
         allRows.forEach((r) => {
            if ((r.hmName ?? '').trim() === userName) homePractices.add(r.practice || 'Unassigned')
         })
      }

      const scopedRows = homePractices.size ? allRows.filter((r) => homePractices.has(r.practice || 'Unassigned')) : allRows

      const isDeferred = (r: DashboardRow) =>
         !!r.isDeferred && r.deferralStatus != 'Pending' && r.deferralStatus != 'Rejected' && r.deferralStatus != 'ReEnabled'

      const hasSubmitted = (isSubmitted: boolean | null | undefined, submittedOn: any) => {
         if (isSubmitted === true) return true
         if (submittedOn == null) return false
         if (typeof submittedOn === 'string' && (submittedOn.trim() === '' || submittedOn.trim().toLowerCase() === 'null')) return false
         return true
      }

      const eligibleRows = scopedRows.filter((r) => !isDeferred(r) && r.revieweeUserStatus !== 'TERMINATED' && r.revieweeUserStatus !== 'LOAINACTIVE')

      const byPractice = new Map<string, DashboardRow[]>()
      eligibleRows.forEach((r) => {
         const practice = r.practice || 'Unassigned'
         if (!byPractice.has(practice)) byPractice.set(practice, [])
         byPractice.get(practice)!.push(r)
      })

      const stats = Array.from(byPractice.entries())
         .map(([practiceName, rows]) => {
            const teamDone = (r: DashboardRow) => hasSubmitted(r.isDVMSubmitted, r.dvmSubmittedOn)
            const hmDone = (r: DashboardRow) => hasSubmitted(r.isCOSSubmitted, r.cosSubmittedOn)

            return {
               practiceName,
               total: rows.length,
               rosterComplete: rows.filter((r) => r.reviewType != null && String(r.reviewType).trim() !== '').length,
               teamComplete: rows.filter(teamDone).length,
               hmSubmitted: rows.filter(hmDone).length,
               bothSubmitted: rows.filter((r) => teamDone(r) && hmDone(r)).length,
               finalized: rows.filter((r) => r.isCompleted).length,
            }
         })
         .sort((a, b) => a.practiceName.localeCompare(b.practiceName))

      if (!stats.length) return

      const total = stats.reduce((sum, s) => sum + s.total, 0)
      const rosterComplete = stats.reduce((sum, s) => sum + s.rosterComplete, 0)
      const teamComplete = stats.reduce((sum, s) => sum + s.teamComplete, 0)
      const hmSubmitted = stats.reduce((sum, s) => sum + s.hmSubmitted, 0)
      const bothSubmitted = stats.reduce((sum, s) => sum + s.bothSubmitted, 0)
      const finalized = stats.reduce((sum, s) => sum + s.finalized, 0)
      const pct = (value: number, count: number) => (count > 0 ? Math.round((value / count) * 100) : 0)

      const aoa: any[][] = [
         [
            this.xlsxHdr('Hospital'),
            this.xlsxHdr('Rosters Complete'),
            this.xlsxHdr('Roster Complete %'),
            this.xlsxHdr('Team Complete'),
            this.xlsxHdr('Team Complete %'),
            this.xlsxHdr('HM Submitted'),
            this.xlsxHdr('HM Submitted %'),
            this.xlsxHdr('Both Submitted'),
            this.xlsxHdr('Both Submitted %'),
            this.xlsxHdr('Finalized Reviews'),
            this.xlsxHdr('Finalized Review %'),
         ],
         [
            this.xlsxCell('OVERALL', 'E6F1FA', true),
            this.xlsxCell(`${rosterComplete}/${total} assigned`, 'E6F1FA', true),
            this.xlsxCell(`${pct(rosterComplete, total)}%`, 'E6F1FA', true),
            this.xlsxCell(`${teamComplete}/${total}`, 'E6F1FA', true),
            this.xlsxCell(`${pct(teamComplete, total)}%`, 'E6F1FA', true),
            this.xlsxCell(`${hmSubmitted}/${total}`, 'E6F1FA', true),
            this.xlsxCell(`${pct(hmSubmitted, total)}%`, 'E6F1FA', true),
            this.xlsxCell(`${bothSubmitted}/${total}`, 'E6F1FA', true),
            this.xlsxCell(`${pct(bothSubmitted, total)}%`, 'E6F1FA', true),
            this.xlsxCell(`${finalized}/${total}`, 'E6F1FA', true),
            this.xlsxCell(`${pct(finalized, total)}%`, 'E6F1FA', true),
         ],
      ]

      stats.forEach((s, i) => {
         const bg = i % 2 === 0 ? 'FFFFFF' : 'F2F8F8'
         aoa.push([
            this.xlsxCell(s.practiceName, bg),
            this.xlsxCell(`${s.rosterComplete}/${s.total} assigned`, bg),
            this.xlsxCell(`${pct(s.rosterComplete, s.total)}%`, bg),
            this.xlsxCell(`${s.teamComplete}/${s.total}`, bg),
            this.xlsxCell(`${pct(s.teamComplete, s.total)}%`, bg),
            this.xlsxCell(`${s.hmSubmitted}/${s.total}`, bg),
            this.xlsxCell(`${pct(s.hmSubmitted, s.total)}%`, bg),
            this.xlsxCell(`${s.bothSubmitted}/${s.total}`, bg),
            this.xlsxCell(`${pct(s.bothSubmitted, s.total)}%`, bg),
            this.xlsxCell(`${s.finalized}/${s.total}`, bg),
            this.xlsxCell(`${pct(s.finalized, s.total)}%`, bg),
         ])
      })

      this.xlsxDownload(aoa, [34, 18, 18, 15, 18, 14, 16, 15, 18, 17, 18], 'Hospital Status', `hospital-status-${dayjs().format('YYYY-MM-DD')}.xlsx`)
   }

   private xlsxDownload(aoa: any[][], cols: number[], sheetName: string, filename: string): void {
      import('xlsx-js-style').then((module) => {
         const XLSXStyle = module.default ?? module
         const ws = XLSXStyle.utils.aoa_to_sheet(aoa)

         ws['!cols'] = cols.map((wch) => ({ wch }))
         ws['!rows'] = aoa.map(() => ({ hpt: 21 }))
         ws['!freeze'] = { xSplit: 0, ySplit: 1 }

         const wb = XLSXStyle.utils.book_new()
         XLSXStyle.utils.book_append_sheet(wb, ws, sheetName)
         const buffer = XLSXStyle.write(wb, {
            bookType: 'xlsx',
            type: 'array',
         })
         const url = URL.createObjectURL(
            new Blob([buffer], {
               type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
         )
         const a = document.createElement('a')
         a.href = url
         a.download = filename
         a.click()

         URL.revokeObjectURL(url)
      })
   }

   private xlsxHdr(v: string): any {
      return {
         v,
         s: {
            font: { bold: true, color: { rgb: 'FFFFFF' }, sz: 11 },
            fill: { fgColor: { rgb: '005E5D' }, patternType: 'solid' },
            alignment: { vertical: 'center', horizontal: 'left' },
            border: { bottom: { style: 'medium', color: { rgb: '1BB5AE' } } },
         },
      }
   }

   private xlsxCell(v: any, bg: string, bold = false, fontRgb = '1A2B2A'): any {
      return {
         v: v ?? '',
         s: {
            font: { sz: 10, bold, color: { rgb: fontRgb } },
            fill: { fgColor: { rgb: bg }, patternType: 'solid' },
            alignment: { vertical: 'center', wrapText: true },
            border: { bottom: { style: 'hair', color: { rgb: 'DDDDDD' } } },
         },
      }
   }

   openUserDeferDialog(row: DashboardRow): void {
      if (!row.reviewType) {
         this.toastr.info('Please set the review type for this user first.')
         return
      }

      this.userDeferDialog.set({ show: true, row })
      this.deferReason = ''
      this.deferQuarter = null
   }

   closeUserDeferDialog(): void {
      this.userDeferDialog.set({ show: false, row: null })
      this.deferReason = ''
      this.deferReasonCategory = ''
      this.deferCategoryOpen = false
      this.deferQuarter = null
   }

   openUserResponsibilitiesDialog(row: DashboardRow): void {
      if (!row.reviewType) {
         this.toastr.info('Please set the review type for this user first.')
         return
      }

      this.userResponsibilitiesDialog.set({ show: true, row })
      this.responsibilityRows = []
      this.isResponsibilitiesLoaded = false

      const reviewType = row.reviewType || this.dash.reviewType

      ;(this.userReviewClient as any).getAdditionalResponsibilities(Number(row.revieweeId), reviewType).subscribe({
         next: async (response: any) => {
            const text = await response.data.text()
            const parsed = JSON.parse(text)
            const savedRow = parsed?.[0]
            let responsibilityTexts: string[] = []

            if (savedRow?.responsibilityText) {
               try {
                  const parsedText = JSON.parse(savedRow.responsibilityText)
                  responsibilityTexts = Array.isArray(parsedText) ? parsedText : [savedRow.responsibilityText]
               } catch (e) {
                  responsibilityTexts = [savedRow.responsibilityText]
               }
            }

            this.responsibilityRows = responsibilityTexts.map((text, index) => ({
               id: savedRow?.id,
               revieweeUserId: savedRow?.revieweeUserId ?? Number(row.revieweeId),
               reviewType: savedRow?.reviewType ?? reviewType,
               responsibilityText: text,
               displayOrder: index + 1,
            }))

            this.isResponsibilitiesLoaded = true
         },
         error: () => {
            this.isResponsibilitiesLoaded = true
            this.toastr.error('Failed to load additional responsibilities')
         },
      })
   }

   closeUserResponsibilitiesDialog(): void {
      this.userResponsibilitiesDialog.set({ show: false, row: null })
      this.responsibilityRows = []
      this.isResponsibilitiesLoaded = false
      this.isSavingResponsibilities = false
      this.showFullReviewPreview = false
      this.dupSaveDialog = { show: false, matches: [] }
      this.existingReviewQuestionsCache = null
      if (this.dupCheckTimer) {
         clearTimeout(this.dupCheckTimer)
         this.dupCheckTimer = null
      }
   }

   addResponsibility(): void {
      const row = this.userResponsibilitiesDialog().row
      if (!row) return

      this.responsibilityRows.push({
         revieweeUserId: row.revieweeId,
         reviewType: row.reviewType || this.dash.reviewType,
         responsibilityText: '',
         displayOrder: this.responsibilityRows.length + 1,
         assignedRevieweeIds: [Number(row.revieweeId)],
      })
   }

   removeResponsibility(index: number): void {
      this.responsibilityRows.splice(index, 1)
      this.responsibilityRows = this.responsibilityRows.map((item, i) => ({ ...item, displayOrder: i + 1 }))
   }

   trackByResponsibility(index: number, item: AdditionalResponsibilityRow): string | number {
      return item.id ? `${item.id}_${index}` : index
   }

   saveResponsibilities(skipDuplicateCheck = false): void {
      const row = this.userResponsibilitiesDialog().row
      if (!row || this.isSavingResponsibilities) return

      if (!skipDuplicateCheck) {
         const matches = this.collectDuplicateMatches()
         if (matches.length > 0) {
            this.dupSaveDialog = { show: true, matches }
            return
         }
      }

      const reviewType = row.reviewType || this.dash.reviewType

      const responsibilities = this.responsibilityRows
         .map((item, index) => ({
            id: item.id,
            revieweeUserId: Number(row.revieweeId),
            reviewType,
            responsibilityText: item.responsibilityText?.trim() ?? '',
            displayOrder: index + 1,
            assignedRevieweeIds: (item as any).assignedRevieweeIds ?? [Number(row.revieweeId)],
         }))
         .filter((item) => item.responsibilityText.length > 0)

      this.isSavingResponsibilities = true
      ;(this.userReviewClient as any)
         .saveAdditionalResponsibilities({
            revieweeUserId: Number(row.revieweeId),
            reviewType,
            includeCareerExploration: row.includeCareerExploration,
            responsibilities,
         })
         .subscribe({
            next: () => {
               this.responsibilityRows = responsibilities
               row.additionalResponsibilitiesCount = responsibilities.length

               this.isSavingResponsibilities = false
               this.toastr.success('Additional responsibilities saved')
               this.closeAssignmentPanel()
            },
            error: () => {
               this.isSavingResponsibilities = false
               this.toastr.error('Failed to save additional responsibilities')
            },
         })
   }

   onUserDeferSubmit(): void {
      if (!this.deferReason?.trim() || this.isSubmittingUpdate) return
      const row = this.userDeferDialog().row
      if (!row) return

      const fullReason = !this.deferReasonCategory
         ? this.deferReason
         : this.deferReason?.trim()
           ? `${this.deferReasonCategory}: ${this.deferReason.trim()}`
           : this.deferReasonCategory

      const finalReviewType = row.reviewType ? row.reviewType : this.dash.reviewType
      const autoApprove = !!this.deferQuarter

      this.isSubmittingUpdate = true
      this.userReviewClient
         .requestDeferral({
            revieweeId: row.revieweeId,
            reviewerUserId: row.hmId,
            reviewType: finalReviewType,
            isDeferred: autoApprove,
            deferReason: fullReason,
            practiceSKey: row.practiceSKey,
            practiceName: row.practice,
            revieweeName: row.name,
            cosName: row.cosName,
            rmName: row.rmName,
            vetLeaderName: row.vetLeaderName,
            directorName: row.directorName,
            vpName: row.vpName,
            hireDate: new Date(row.hireDate),
            whenCompletedBy: this.deferQuarter,
            cycle: finalReviewType === 'DVM' ? `aDVM ${this.dash.selectedCycle}` : this.deferQuarter ? 'OPEN' : finalReviewType,
         })
         .subscribe({
            next: () => {
               this.isSubmittingUpdate = false
               if (autoApprove) {
                  row.isDeferred = true
                  row.deferralStatus = 'Approved'
                  row.hasPendingDeferralRequest = false
                  this.closeUserDeferDialog()
                  this.dash.applyFiltersSort()
                  this.toastr.success(`Deferral approved. Review moved to Open Cycle.`)
               } else {
                  row.hasPendingDeferralRequest = true
                  row.deferralStatus = 'Pending'
                  this.closeUserDeferDialog()
                  this.toastr.success('Deferral request has been successfully submitted.')
               }
            },
            error: () => {
               this.isSubmittingUpdate = false
               console.error('Failed to submit deferral request')
            },
         })
   }

   openUserFollowUpDialog(row: DashboardRow): void {
      this.userFollowUpDialog.set({ show: true, row })
      this.userFollowUpMessages = []
      this.userFollowUpMessage = ''
      this.userFollowUpLoading = true

      this.userReviewClient.getDeferralRequests().subscribe({
         next: (requests) => {
            const req = requests
               .filter((r: any) => r.revieweeId == row.revieweeId && r.status === 'Pending')
               .sort((a: any, b: any) => new Date(b.requestedOn).getTime() - new Date(a.requestedOn).getTime())[0]
            if (!req) {
               this.userFollowUpLoading = false
               return
            }

            this.userFollowUpDeferredOn = req.requestedOn

            this.userReviewClient.getDeferralFollowUps(req.id).subscribe({
               next: (data) => {
                  this.userFollowUpMessages = data.map((d: any) => ({
                     id: d.id,
                     deferralId: d.deferralId,
                     message: d.message,
                     sentById: d.sentById,
                     sentByName: d.sentByName,
                     isAdmin: d.isAdmin,
                     sentOn: d.sentOn,
                  }))
                  this.userFollowUpLoading = false
               },
               error: () => {
                  this.userFollowUpLoading = false
               },
            })
         },
         error: () => {
            this.userFollowUpLoading = false
         },
      })
   }

   closeUserFollowUpDialog(): void {
      this.userFollowUpDialog.set({ show: false, row: null })
      this.userFollowUpMessages = []
      this.userFollowUpMessage = ''
      this.userFollowUpDeferredOn = null
   }

   sendUserFollowUp(): void {
      if (!this.userFollowUpMessage?.trim()) return
      const row = this.userFollowUpDialog().row
      if (!row) return
      this.userFollowUpSaving = true

      this.userReviewClient.getDeferralRequests().subscribe({
         next: (requests) => {
            const req = requests
               .filter((r: any) => r.revieweeId == row.revieweeId && r.status === 'Pending')
               .sort((a: any, b: any) => new Date(b.requestedOn).getTime() - new Date(a.requestedOn).getTime())[0]
            if (!req) {
               this.userFollowUpSaving = false
               return
            }

            this.userReviewClient
               .addDeferralFollowUp(req.id, {
                  deferralId: req.id,
                  message: this.userFollowUpMessage.trim(),
                  isAdmin: false,
                  revieweeId: req.revieweeId,
               })
               .subscribe({
                  next: () => {
                     this.userFollowUpMessages.push({
                        id: Date.now(),
                        deferralId: req.id,
                        message: this.userFollowUpMessage.trim(),
                        sentById: '',
                        sentByName: this.dash.userName,
                        isAdmin: false,
                        sentOn: new Date(),
                     })
                     this.userFollowUpMessage = ''
                     this.userFollowUpSaving = false
                     row.hasAdminFollowUp = false
                  },
                  error: () => {
                     this.userFollowUpSaving = false
                  },
               })
         },
         error: () => {
            this.userFollowUpSaving = false
         },
      })
   }

   openRejectedDialog(row: DashboardRow): void {
      this.rejectedDialog.set({ show: true, row })
      this.rejectedDialogRejectReason = ''
      this.rejectedDialogResolvedBy = ''
      this.rejectedDialogResolvedOn = null

      this.userReviewClient.getDeferralRequests().subscribe({
         next: (requests) => {
            const req = requests
               .filter((r: any) => r.revieweeId == row.revieweeId && r.status === 'Rejected')
               .sort((a: any, b: any) => new Date(b.requestedOn).getTime() - new Date(a.requestedOn).getTime())[0]
            if (!req) return

            this.rejectedDialogRejectReason = req.rejectReason || 'No reason provided.'
            this.rejectedDialogResolvedBy = req.resolvedByName || ''
            this.rejectedDialogResolvedOn = req.resolvedOn
         },
      })
   }

   closeRejectedDialog(): void {
      this.rejectedDialog.set({ show: false, row: null })
      this.rejectedDialogRejectReason = ''
      this.rejectedDialogResolvedBy = ''
      this.rejectedDialogResolvedOn = null
   }

   selectDeferCategory(label: string): void {
      this.deferReasonCategory = label
      this.deferCategoryOpen = false
      this.deferReason = ''
      if (!this.canSelectDeferQuarter) {
         this.deferQuarter = null
      } else if (
         this.deferReasonCategory == this.deferCategoryOptions[0].label ||
         this.deferReasonCategory == this.deferCategoryOptions[1].label ||
         this.deferReasonCategory == this.deferCategoryOptions[5].label ||
         this.deferReasonCategory == this.deferCategoryOptions[6].label
      ) {
         this.deferQuarter = '1 Year'
      } else {
         this.deferQuarter = null
      }
   }

   setResponsibilityTab(index: number, tab: 'write' | 'preview'): void {
      const item = this.responsibilityRows[index]
      if (!item) return
      item.activeTab = tab
   }

   onResponsibilityTextChanged(index: number): void {
      if (this.dupCheckTimer) clearTimeout(this.dupCheckTimer)
      this.dupCheckTimer = setTimeout(() => {
         const item = this.responsibilityRows[index]
         if (!item) return
         const match = this.findSimilarExistingQuestion(item.responsibilityText ?? '', index)
         item.dupMatch = match
      }, 400)
   }

   openFullReviewPreview(): void {
      this.fullReviewSections = this.buildFullReviewSections()
      this.showFullReviewPreview = true
   }

   closeFullReviewPreview(): void {
      this.showFullReviewPreview = false
   }

   confirmSaveDespiteDuplicates(): void {
      this.dupSaveDialog = { show: false, matches: [] }
      this.saveResponsibilities(true)
   }

   private getReviewTemplateForCurrentType(): any {
      if (this.userResponsibilitiesDialog().row?.reviewType == 'CROSSTRAINED') {
         return CROSS_TRAINED_REVIEW_TEMPLATE
      } else if (this.userResponsibilitiesDialog().row?.reviewType == 'CLINICAL') {
         return CLINICAL_REVIEW_TEMPLATE
      } else if (this.userResponsibilitiesDialog().row?.reviewType == 'RECEPTION') {
         return RECEPTION_REVIEW_TEMPLATE
      } else {
         return null
      }
   }

   private buildFullReviewSections(): FullReviewPreviewSection[] {
      const template = this.getReviewTemplateForCurrentType()
      const sections: FullReviewPreviewSection[] = []

      const mapQuestion = (q: any): FullReviewPreviewQuestion | null => {
         const label = q.reviewerLabel || q.revieweeLabel || ''
         if (!label && q.type !== 'table') return null

         return {
            label,
            required: !!q.required,
            type: q.type,
            options: (q.reviewerOptions || q.revieweeOptions || q.options || []).map((o: any) => o.label),
            columns: (q.tableColumns || []).map((c: any) => c.label),
         }
      }

      for (const section of template?.sections ?? []) {
         const title = section.reviewerTitle || section.revieweeTitle || ''
         const questions = (section.questions ?? [])
            .map(mapQuestion)
            .filter((q: FullReviewPreviewQuestion | null): q is FullReviewPreviewQuestion => !!q)

         if (questions.length === 0) continue

         const clinicalMatch = /^Clinical Skills\s*-\s*(.+)$/.exec(title)
         if (clinicalMatch) {
            let clinical = sections.find((s) => s.title === 'Clinical Skills')
            if (!clinical) {
               clinical = { title: 'Clinical Skills', questions: [] }
               sections.push(clinical)
            }
            clinical.questions.push({
               label: clinicalMatch[1],
               required: false,
               type: 'subtitle',
               options: [],
               columns: [],
               showMarkNotApplicable: true,
            })
            clinical.questions.push(...questions)
            continue
         }

         sections.push({ title, questions })
      }

      return sections
   }

   private getExistingReviewQuestions(): string[] {
      if (this.existingReviewQuestionsCache) return this.existingReviewQuestionsCache

      const template = this.getReviewTemplateForCurrentType()
      const questions: string[] = []

      for (const section of template?.sections ?? []) {
         for (const q of section.questions ?? []) {
            if (q.type === 'static') continue
            const label = this.stripHtml(q.reviewerLabel || q.revieweeLabel || '')
            if (label) questions.push(label)
         }
      }

      this.existingReviewQuestionsCache = questions
      return questions
   }

   private stripHtml(value: string): string {
      return (value || '')
         .replace(/<[^>]*>/g, ' ')
         .replace(/&[a-z]+;/gi, ' ')
         .replace(/\s+/g, ' ')
         .trim()
   }

   private static readonly DUP_STOP_WORDS = new Set([
      'the',
      'a',
      'an',
      'and',
      'or',
      'of',
      'for',
      'to',
      'in',
      'on',
      'with',
      'is',
      'are',
      'be',
      'as',
      'at',
      'by',
      'that',
      'this',
      'their',
      'our',
      'all',
      'any',
      'each',
      'per',
      'etc',
   ])

   private tokenizeForDupCheck(value: string): string[] {
      return (value || '')
         .toLowerCase()
         .replace(/[^a-z0-9\s]/g, ' ')
         .split(/\s+/)
         .filter((word) => word.length > 2 && !DVMToolTeamDashboardModalsComponent.DUP_STOP_WORDS.has(word))
   }

   private dupSimilarity(a: string, b: string): number {
      const tokensA = new Set(this.tokenizeForDupCheck(a))
      const tokensB = new Set(this.tokenizeForDupCheck(b))
      if (tokensA.size === 0 || tokensB.size === 0) return 0

      let overlap = 0
      tokensA.forEach((word) => {
         if (tokensB.has(word)) overlap++
      })

      return overlap / Math.min(tokensA.size, tokensB.size)
   }

   private findSimilarExistingQuestion(text: string, currentIndex: number | null = null): string | null {
      if (this.tokenizeForDupCheck(text).length < 2) return null

      const candidates = [...this.getExistingReviewQuestions()]

      this.responsibilityRows.forEach((other, i) => {
         if (i !== currentIndex && other.responsibilityText?.trim()) {
            candidates.push(other.responsibilityText.trim())
         }
      })

      let best: string | null = null
      let bestScore = 0
      for (const candidate of candidates) {
         const score = this.dupSimilarity(text, candidate)
         if (score > bestScore) {
            bestScore = score
            best = candidate
         }
      }

      return bestScore >= 0.5 ? best : null
   }

   private collectDuplicateMatches(): Array<{ text: string; existing: string }> {
      const matches: Array<{ text: string; existing: string }> = []

      this.responsibilityRows.forEach((item, index) => {
         const text = item.responsibilityText?.trim()
         if (!text) return
         const existing = this.findSimilarExistingQuestion(text, index)
         if (existing) matches.push({ text, existing })
      })

      return matches
   }

   openAssignmentPanel(index: number): void {
      this.activeResponsibilityIndex = index
      this.assignmentPanelOpen = true
      this.assignmentSearch = ''

      const currentRow = this.userResponsibilitiesDialog().row
      const item = this.responsibilityRows[index] as any

      if (!item.assignedRevieweeIds) {
         item.assignedRevieweeIds = currentRow?.revieweeId ? [Number(currentRow.revieweeId)] : []
      }
   }

   closeAssignmentPanel(): void {
      this.assignmentPanelOpen = false
      this.activeResponsibilityIndex = null
      this.assignmentSearch = ''
   }

   getAssignableTeamMembers(): DashboardRow[] {
      const currentRow = this.userResponsibilitiesDialog().row
      const search = this.assignmentSearch?.trim().toLowerCase()

      return (this.dash.dashboardRows ?? [])
         .filter((row) => row.hmName == this.dash.userName)
         .filter((row) => row.revieweeId?.toString() !== currentRow?.revieweeId?.toString())
         .filter((row) => {
            if (!search) return true

            return row.name?.toLowerCase().includes(search)
         })
         .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
   }

   isAssignedToTeamMember(revieweeId: string | number): boolean {
      if (this.activeResponsibilityIndex === null) return false

      const item = this.responsibilityRows[this.activeResponsibilityIndex] as any
      return (item.assignedRevieweeIds ?? []).includes(Number(revieweeId))
   }

   toggleAssignedTeamMember(revieweeId: string | number, checked: boolean): void {
      if (this.activeResponsibilityIndex === null) return

      const item = this.responsibilityRows[this.activeResponsibilityIndex] as any
      const ids = item.assignedRevieweeIds ?? []

      item.assignedRevieweeIds = checked ? Array.from(new Set([...ids, Number(revieweeId)])) : ids.filter((id: number) => id !== Number(revieweeId))
   }

   getAssignedCount(index: number): number {
      const count = ((this.responsibilityRows[index] as any)?.assignedRevieweeIds ?? []).length
      return Math.max(0, count - 1)
   }

   openJobDescDialog(row: DashboardRow): void {
      this.jobDescDialog.set({ show: true, row })
      this.jobDescSelections = {}
      this.lockedJobDesc = JOB_DESCRIPTIONS[row.jobTitleCode ?? '']?.label ?? ''
      this.isJobDescsLoaded = false
      ;(this.userReviewClient as any).getJobDescriptions(Number(row.revieweeId), 'CROSSTRAINED').subscribe({
         next: async (response: any) => {
            let codes: string[] = []
            try {
               const raw = response?.data?.text ? JSON.parse(await response.data.text()) : response
               codes = Array.isArray(raw) ? raw : []
            } catch {
               codes = []
            }

            const selected = [this.lockedJobDesc, ...codes.filter((c) => c && c !== this.lockedJobDesc)].filter(Boolean).slice(0, 2)
            for (const c of selected) this.jobDescSelections[c] = true
            this.isJobDescsLoaded = true
         },
         error: () => {
            this.isJobDescsLoaded = true
            this.toastr.error('Failed to load job description selections')
         },
      })
   }

   get selectedJobDescCount(): number {
      return Object.values(this.jobDescSelections).filter(Boolean).length
   }

   isJobDescDisabled(label: string): boolean {
      return label === this.lockedJobDesc || (!this.jobDescSelections[label] && this.selectedJobDescCount >= 2)
   }

   closeJobDescDialog(): void {
      this.jobDescDialog.set({ show: false, row: null })
      this.jobDescSelections = {}
      this.isJobDescsLoaded = false
      this.isSavingJobDescs = false
   }

   saveJobDescSelections(): void {
      const row = this.jobDescDialog().row
      if (!row || this.isSavingJobDescs) return

      const codes = this.jobDescriptionOptions.filter((d) => this.jobDescSelections[d.label]).map((d) => d.label)
      if (codes.length === 0) {
         this.toastr.info('Please select at least one job description.')
         return
      }

      this.isSavingJobDescs = true
      ;(this.userReviewClient as any)
         .saveJobDescriptions({
            revieweeUserId: Number(row.revieweeId),
            jobDescriptions: codes,
         })
         .subscribe({
            next: () => {
               this.isSavingJobDescs = false
               this.toastr.success('Job descriptions saved')
               this.closeJobDescDialog()
            },
            error: () => {
               this.isSavingJobDescs = false
               this.toastr.error('Failed to save job descriptions')
            },
         })
   }
}
